import { render, staticRenderFns } from "./MPPILayout.vue?vue&type=template&id=1be0f4c6&"
import script from "./MPPILayout.vue?vue&type=script&lang=js&"
export * from "./MPPILayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports